import { Box, Button, Card, CardActionArea, Typography } from "@mui/material";
import Scrollbar from "components/scrollbar";
import { MasterItemSkeleton } from "components/skeleton";
import { AppointmentContext } from "context/AppointmentContext";
import useApi from "hooks/useApi";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { APPOINTMENT, PASSING_DATE_FORMAT } from "utils/constant";


export default function BookingTimeslotSelection() {
    const { apiCalling } = useApi()
    let { companyId } = useContext(AppointmentContext)
    let { watch, setValue } = useFormContext()
    let appointmentDate = watch('date')
    let selectedSlot = watch('slot')

    const [loadingTimeslot, setLoadingTimeslot] = useState(false)
    const [availableSlotList, setAvailableSlotList] = useState([])
    const [errorMessage, setErrorMessage] = useState('');
    const [serviceBookingInfo, setServiceBookingInfo] = useState(null)

    useEffect(() => {
        if (!companyId || !appointmentDate) return;
        const controller = new AbortController();
        const { signal } = controller;

        const GetTimeSlotList = async () => {
            try {
                setLoadingTimeslot(true);
                let params = {
                    company_id: decodeURIComponent(companyId),
                    appointment_date: moment(appointmentDate).format(PASSING_DATE_FORMAT)
                }
                const response = await apiCalling({ url: APPOINTMENT.customerAppointmentSlot, params, signal: signal });
                let data = response?.data?.result;
                setServiceBookingInfo(data?.config)
                let config = data?.dates?.[0] || null;
                if (!!config?.slots?.length) {
                    setAvailableSlotList(config?.slots)
                    setErrorMessage('')
                } else {
                    setErrorMessage(config?.message)
                }
            } catch (error) {
                if (error.name !== "AbortError") { console.error(error); }
            } finally {
                setLoadingTimeslot(false);
            }
        };
        GetTimeSlotList();
        return () => controller.abort();
    }, [companyId, appointmentDate]);


    return (
        <Box sx={{ display: "flex", height: 1, flexDirection: "column", p: { xs: 3, md: 3 }, borderLeft: { md: "2px solid #E5E7EB" } }} >
            {appointmentDate && (
                <>
                    <Typography variant="h6" mb={3} color="text.secondary"> {appointmentDate.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric", })} </Typography>

                    <Scrollbar sx={{ maxHeight: { xs: "none", md: "62vh" }, }}>
                        <Box sx={{ display: "flex", flexDirection: "row", flexWrap: 'wrap', gap: 1.5 }}>
                            {loadingTimeslot ?
                                <Card><MasterItemSkeleton loadTime={10} /></Card>
                                :
                                errorMessage
                                    ?
                                    <Typography color="error" variant="body1" >{errorMessage}</Typography>
                                    :
                                    availableSlotList?.map((item, _i) => {
                                        let { start_time_formatted = '', end_time_formatted = '', start_time, end_time } = item || {}
                                        const active = item?.end_time_formatted == selectedSlot?.end_time_formatted;
                                        return (
                                            <Box key={_i} sx={{ gap: 1.5, width: 'calc(50% - 16px)' }} >
                                                <Card
                                                    onClick={() => {
                                                        setValue('slot', item)
                                                        setValue('from_time', new Date(start_time), { shouldDirty: true })
                                                        setValue('to_time', new Date(end_time), { shouldValidate: true })
                                                        setValue('showForm', true)
                                                    }}
                                                    component={CardActionArea}
                                                    sx={{
                                                        p: 1.5,
                                                        boxShadow: 'none',
                                                        border: "1px solid",
                                                        borderColor: active ? "transparent" : "primary.main",
                                                        bgcolor: active ? "primary.main" : "background.paper",
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    <Typography variant="caption" sx={{ color: active ? "primary.contrastText" : "primary.main" }} >
                                                        {`${start_time_formatted} - ${end_time_formatted}`}
                                                    </Typography>
                                                </Card>
                                            </Box>
                                        );
                                    })}
                        </Box>
                    </Scrollbar>
                </>
            )}
        </Box>
    );
}